// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__3pY_r","detailsBorder":"styles_detailsBorder__1hYLd"};